'use strict';

import DefaultGenerator from "./DefaultGenerator.js";
export default class XLSXGenerator extends DefaultGenerator{
	_mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	_extension = 'xlsx';

	generate(data, sub = false, offset = 0, prevHeadingsLength = 0) {
		let xml = '';

		if (!Array.isArray(data)){
			data = [data];
		}

		const headings = Object.keys(data[0]);

		const offsetCols = (count = offset) => {
			if (count < 0) return '';
			let cols = '';
			for (let i = 0; i < count; i++) {
				cols += `<c t="inlineStr"><is><t xml:space="preserve"></t></is></c>`
			}

			return cols;
		}

		if (sub) {
			xml += `<row>`;
			xml += offsetCols();
			headings.forEach((key, index) => {
				xml += `<c t="inlineStr" s="2"><is><t xml:space="preserve">${this.htmlEncode(key)}</t></is></c>`;
			});
			xml += offsetCols(prevHeadingsLength - headings.length - 1);
			xml += '</row>';
		}

		data.forEach((row, index) => {
			xml += `<row>`;
			xml += offsetCols();
			let subHeadings = [];
			let subRows = '';
			Object.values(row).forEach((value, index) => {
				let val = value;
				if (typeof value.subitems === 'object') {
					val = value.value
				}
				val = this.extractTextFromHtml(val);

				if (/^\d+$/.test(val)) {
					xml += `<c>
								<v>${val}</v>
							</c>`
				} else {
					xml += `<c t="inlineStr">
								<is>
									<t xml:space="preserve">${this.htmlEncode(val)}</t>
								</is>
							</c>`
				}

				if (typeof value.subitems === 'object') {
					const subRowsData = this.generate(value.subitems, true, index + offset, headings.length);
					subRows = subRowsData.xml
					subHeadings = subRowsData.headings
				}

			});
			xml += offsetCols(headings.length - subHeadings.length - 1);

			xml += '</row>'
			xml += subRows;
		});

		return sub ? {xml, headings} : super.generate(data,xml);
	}


	 extractTextFromHtml(html) {
		let doc = new DOMParser().parseFromString(html, 'text/html');
		return doc.body.textContent || "";
	}

	download() {
		this._filename = 'Levcharity ' + this._filename_default;
		super.download();
	}

	numberToChar(number) {
		let result = '';
		while (number > 0) {
			const remainder = (number - 1) % 26;
			result = String.fromCharCode(remainder + 97) + result;
			number = Math.floor((number - 1) / 26);
		}
		return result.toUpperCase();
	}

	htmlEncode(str) {
		return str.replace(/[\u00A0-\u9999<>&]/gim, function(i) {
			return '&#' + i.charCodeAt(0) + ';';
		});
	}
}

const exampleData = [
	{
		Name: "John",
		Age: 30,
		City: "New York",
		Contacts: {
			value: 'asd',
			subitems: [
				{Phone: "123-456-7890", Email: "john@example.com"},
				{Phone: "123-456-7890", Email: "john@example.com"},
				{Phone: "123-456-7890", Email: "john@example.com"},
			]
		}
	},
	{
		Name: "Alice",
		Age: 25,
		City: "Los Angeles",
		Contacts: {
			value: 'asd',
			subitems: [
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
				{Phone: "987-654-3210", Email: "alice@example.com"},
			]
		}
	},
	{
		Name: "Bob",
		Age: 35,
		City: "Chicago",
		Contacts: {
			value: 'asd',
			subitems: [
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"},
				{Phone: "555-555-5555", Email: "bob@example.com"}
			]
		}
	}
];
